import * as React from "react";
import { Field, useFormikContext } from "formik";
import styled from "styled-components";
import { useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";
import Input from "components/bootstrap/Input";
import QueryValidation from "views/components/searchbar/queryvalidation/QueryValidation";
import FormWarningsContext from "contexts/FormWarningsContext";
import { ParameterDeclarationProvider } from "search-filter/logic/ParameterDeclarationProvider";
import useView from "search-filter/hooks/useView";
import ViewsQueryInput from "views/components/searchbar/ViewsQueryInput";
const Container = styled.div`
  display: flex;
`;
const QueryStringFormGroup = ({
  labelClassName = "col-sm-3",
  wrapperClassName = "col-sm-9",
  timeRange = {},
  streams = []
}) => {
  const view = useView();
  const { isValidating, handleSubmit, validateForm, isSubmitting, isValid } = useFormikContext();
  const { warnings } = useContext(FormWarningsContext);
  const { t } = useTranslation("enterprise_search");
  const disableExecution = isSubmitting || isValidating || !isValid;
  const onSaveParametersSuccess = useCallback(
    ({ toggleShowDeclarationForm }) => {
      toggleShowDeclarationForm();
    },
    []
  );
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "queryString",
      labelClassName,
      wrapperClassName,
      help: t("query_string_form_group.help"),
      label: t("query_string_form_group.query")
    },
    /* @__PURE__ */ React.createElement(
      Field,
      {
        name: "queryString",
        label: t("query_string_form_group.query"),
        id: "queryString-field",
        title: t("query_string_form_group.field_title")
      },
      ({ field: { name, value, onChange }, meta: { error } }) => /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(
        ViewsQueryInput,
        {
          value,
          view,
          placeholder: t("query_string_form_group.placeholder"),
          error,
          inputId: name,
          isValidating,
          warning: warnings == null ? void 0 : warnings.queryString,
          onChange,
          name,
          timeRange,
          streams,
          disableExecution,
          validate: validateForm,
          onExecute: handleSubmit
        }
      ), /* @__PURE__ */ React.createElement(
        ParameterDeclarationProvider,
        {
          value: {
            onSaveParametersSuccess
          }
        },
        /* @__PURE__ */ React.createElement(QueryValidation, null)
      ))
    )
  );
};
export default QueryStringFormGroup;
